import styled, { css } from 'styled-components';

// We use a styled component to enabled changing the element with the "as" prop
export const StyledContainer = styled.span<{
  noSpacing?: boolean;
}>`
  ${({ noSpacing }) => noSpacing && css`
    > * {
      &:first-child {
        padding-top: 0;
        margin-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
  `}
`;
